import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const BookmarkOutlineIcon: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g {...(props.group ?? {})}>
      <path
        d="M5.94773 2C5.42459 2 5 2.42273 5 2.9457V20.0546C5 20.4205 5.21134 20.7534 5.54306 20.9095C5.87477 21.0655 6.26714 21.0173 6.54955 20.7846L11.9991 16.3113L17.4486 20.7846C17.7329 21.0173 18.1253 21.0645 18.455 20.9095C18.7868 20.7534 18.9981 20.4196 18.9981 20.0546L19 2.9457C19 2.42368 18.5764 2 18.0523 2H5.94773ZM17.1044 18.0526L12.6026 14.3566C12.2529 14.0691 11.7477 14.0691 11.399 14.3566L6.89712 18.0526L6.89618 3.89154H17.1042L17.1044 18.0526Z"
        fill={fillColor}
      />
    </g>
  );
};

export const BookmarkOutlineIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      data-testid="bookmark-outline-icon"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <BookmarkOutlineIcon {...props} />
    </svg>
  );
};
